import {Injectable} from 'ng-metadata/core';

@Injectable()
export class LanguageSelectionService {
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/userArea/languageSelection/languageSelection.service.ts